module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-wrapper"
  }, [_c('header', [_c('nav', {
    staticClass: "navbar navbar-inverse"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle nav-expander",
    attrs: {
      "type": "button",
      "id": "nav-expander"
    },
    on: {
      "click": _vm.openExpander
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('a', {
    staticClass: "navbar-brand"
  }, [_c('img', {
    attrs: {
      "src": "images/logo.png",
      "alt": "FRL logo"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-menu text-center"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "nav-close hidden-md hidden-lg"
  }, [_c('a', {
    attrs: {
      "id": "nav-close"
    },
    on: {
      "click": _vm.closeExpander
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', [_vm._v("HOME")])]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.isProject
    },
    attrs: {
      "to": "/proven-benefits",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("BRICK FUNDRAISING")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/proven-benefits",
      "active-class": "active"
    }
  }, [_vm._v("\n                                    Proven Benefits\n                                ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/unmatched-quality",
      "active-class": "active"
    }
  }, [_vm._v("\n                                    Unmatched Quality\n                                ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/fundraising-toolkit",
      "active-class": "active"
    }
  }, [_vm._v("\n                                    Fundraising Toolkit\n                                ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/product-guide",
      "active-class": "active"
    }
  }, [_vm._v("\n                                    Product Guide\n                                ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/how-it-works",
      "active-class": "active"
    }
  }, [_vm._v("\n                                    How It Works\n                                ")])], 1)]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.isPortfolio
    },
    attrs: {
      "to": "/portfolio",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("PORTFOLIO")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/about-us",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("ABOUT US")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/faq",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("FAQ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("CONTACT")])])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "section-wrapper"
  }, [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "main-container"
  }, [(_vm.$route.path !== '/intro-offer') ? _c('div', {
    staticClass: "intro-offer-teaser"
  }) : _vm._e(), _vm._v(" "), _c(this.$route.meta.layout || 'div', {
    tag: "component"
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-footer safari-only"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "pf-inner"
  }, [_c('p', [_vm._v("START YOUR FUNDRAISER TODAY!")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/open-contact-form",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("REQUEST MORE INFORMATION")])])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('inscription-guidelines-popup'), _vm._v(" "), _c('inscription-examples-popup')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "footer-inner"
  }, [_c('p', [_vm._v("© 2018 Fund Raisers, Ltd. All Rights Reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "privacy-policy"
  }, [_c('a', {
    attrs: {
      "href": "https://fundraiserssports.com/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('ul', {
    staticClass: "social list-inline"
  }, [_c('li', {
    staticClass: "facebook"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/fundraiserssports/",
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "linkedin"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/fund-raisers-sports",
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "twitter"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/TeamFundRaisers",
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "instagram"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/fundraiserssports/",
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "pinterest"
  }, [_c('a', {
    attrs: {
      "href": "https://www.pinterest.com/fundraiserssports/",
      "target": "_blank"
    }
  })])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.fundraiserssports.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "footer-text"
  }, [_vm._v("FUND RAISERS SPORTS")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2622e898","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/Website.vue
// module id = /rAf
// module chunks = 1